import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./ServiceBlockBerlinGrid.module.scss";

export interface Service {
  id: string;
  title: string;
  description: string;
  list?: string[];
}

interface ServiceBlockBerlinGridProps {
  services: Service[];
}

const ServiceBlockBerlinGrid: React.FC<ServiceBlockBerlinGridProps> = ({
  services,
}) => {
  const { t } = useTranslation("common");

  return (
    <div className={`${styles.serviceMain}`}>
      <div className={styles.gradOverlayTop}></div>
      <div className={`${styles.serviceBlock} sideP88`}>
        <h3 className={styles.blockSubtitle}>
          {t("serviceBlockBerlin.subtitle")}
        </h3>
        <div className={styles.gridContainer}>
          {services.map((service) => (
            <div key={service.id} className={styles.serviceItem}>
              <p className={styles.idBlock}>{service.id}.</p>
              <div className={styles.infoDescription}>
                <h5>{service.title}</h5>
                <p>{service.description}</p>

                {service.list?.length ? (
                  <ul>
                    {service.list.map((item, index) => (
                      <li key={index} className={styles.listItem}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="none"
                          aria-hidden="true"
                        >
                          <path
                            fill="#1F5459"
                            fillRule="evenodd"
                            d="M8 16a8 8 0 0 0 7.293-11.293l-7.96 7.96L2.666 8h2l2.667 2.667 7.235-7.235A8 8 0 1 0 8 16Z"
                            clipRule="evenodd"
                          />
                        </svg>
                        {item}
                      </li>
                    ))}
                  </ul>
                ) : null}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiceBlockBerlinGrid;
